import(/* webpackMode: "eager" */ "/test-choon/app/global-error.tsx");
